import React, { useContext } from 'react';
import { Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import SettingsContext from '../context/SettingsContext';

// 구독 상태에 따른 상단 배너
// - trialing & 카드 미등록 & 만료 <= 7일: 노란 경고 (체험 종료 임박 → 카드 등록 유도)
// - trialing & 카드 미등록 & 만료 0일/지남: 빨간 (체험 종료, 카드 등록 필요)
//   (카드 등록(scheduled)한 매장은 만료일 cron 이 자동 결제하므로 안내 안 함)
// - past_due: 빨간 (결제 실패)
// - canceled: 빨간 (구독 종료, 재구독 안내)
// - active: 표시 안 함

const SubscriptionBanner = () => {
    const { subscriptionStatus, trialDaysLeft, trialExpired, hasPaymentMethod,
            isNonpaymentDormant, purgeDate } = useContext(SettingsContext);

    // 장기 미결제로 자동 휴면된 매장 — 파기 예정일이 박혀 있다. 가장 긴급하므로 맨 앞에서 처리.
    // 로그인은 열어두되(재결제하러 와야 하니까) 무엇이 언제 사라지는지 분명히 알린다.
    if (isNonpaymentDormant && purgeDate) {
        const d = purgeDate.toLocaleDateString('ko-KR', { year: 'numeric', month: 'long', day: 'numeric' });
        return (
            <Alert variant="danger" className="mb-0 rounded-0">
                <strong>{d}에 매장 데이터가 영구 삭제됩니다.</strong>{' '}
                장기 미결제로 휴면 상태입니다. 그 전에{' '}
                <Link to="/account/billing" className="alert-link fw-bold">결제를 재개</Link>하시면
                휴면이 해제되고 데이터가 그대로 유지됩니다.
            </Alert>
        );
    }

    if (!subscriptionStatus || subscriptionStatus === 'active') {
        return null;
    }

    if (subscriptionStatus === 'trialing') {
        // 이미 카드를 등록(scheduled)한 매장은 만료일에 자동 결제되므로 안내 불필요
        if (hasPaymentMethod) {
            return null;
        }
        if (trialExpired) {
            return (
                <Alert variant="danger" className="mb-0 rounded-0">
                    <strong>무료 체험이 종료되었습니다.</strong> 서비스를 계속 이용하려면{' '}
                    <Link to="/account/billing">결제 카드를 등록</Link>해주세요.
                </Alert>
            );
        }
        if (trialDaysLeft !== null && trialDaysLeft <= 7) {
            return (
                <Alert variant="warning" className="mb-0 rounded-0">
                    <strong>무료 체험이 {trialDaysLeft}일 후 종료됩니다.</strong>{' '}
                    <Link to="/account/billing">지금 카드를 등록</Link>하시면 끊김 없이 이용할 수 있습니다.
                </Alert>
            );
        }
        return null;
    }

    if (subscriptionStatus === 'past_due') {
        return (
            <Alert variant="danger" className="mb-0 rounded-0">
                <strong>결제에 실패했습니다.</strong> 3일 안에 결제가 정상화되지 않으면 서비스 사용이 제한됩니다.{' '}
                <Link to="/account/billing" className="alert-link fw-bold">지금 다시 시도하기 →</Link>
            </Alert>
        );
    }

    if (subscriptionStatus === 'canceled' || subscriptionStatus === 'none') {
        return (
            <Alert variant="danger" className="mb-0 rounded-0">
                <strong>구독이 종료되었습니다.</strong>{' '}
                <Link to="/account/billing">재구독하기</Link>
            </Alert>
        );
    }

    return null;
};

export default SubscriptionBanner;
